/**
 * Lightweight cart-drawer complementary/related recommendations.
 * complementary first, related fallback; exclude cart + OOS; quick-add refreshes drawer.
 */
(function () {
  var pending = null;
  var debounceTimer = null;

  function moneyFromCents(cents, currency) {
    try {
      return (cents / 100).toLocaleString('he-IL', {
        style: 'currency',
        currency: currency || (window.Shopify && Shopify.currency && Shopify.currency.active) || 'ILS',
        maximumFractionDigits: 0,
      });
    } catch (e) {
      return '₪' + Math.round(cents / 100);
    }
  }

  function cartIdSet(root) {
    var raw = (root.getAttribute('data-cart-product-ids') || '').split(',');
    var set = {};
    for (var i = 0; i < raw.length; i++) {
      var id = String(raw[i] || '').trim();
      if (id) set[id] = true;
    }
    return set;
  }

  function pickProducts(list, exclude, limit) {
    var out = [];
    for (var i = 0; i < (list || []).length && out.length < limit; i++) {
      var p = list[i];
      if (!p || !p.available) continue;
      if (exclude[String(p.id)]) continue;
      var variant = null;
      var variants = p.variants || [];
      for (var v = 0; v < variants.length; v++) {
        if (variants[v].available) {
          variant = variants[v];
          break;
        }
      }
      if (!variant) continue;
      out.push({ product: p, variant: variant });
    }
    return out;
  }

  function fetchIntent(productId, intent) {
    var url =
      '/recommendations/products.json?product_id=' +
      encodeURIComponent(productId) +
      '&limit=10&intent=' +
      encodeURIComponent(intent);
    return fetch(url, { credentials: 'same-origin' }).then(function (r) {
      if (!r.ok) throw new Error('rec ' + r.status);
      return r.json();
    });
  }

  function render(root, items, heading) {
    var list = root.querySelector('[data-upsell-list]');
    var headingEl = root.querySelector('[data-upsell-heading]');
    if (!list || !headingEl) return;
    headingEl.textContent = heading || '';
    list.innerHTML = '';
    if (!items.length) {
      root.hidden = true;
      return;
    }
    root.hidden = false;
    for (var i = 0; i < items.length; i++) {
      var row = items[i];
      var p = row.product;
      var v = row.variant;
      var li = document.createElement('li');
      li.className = 'cart-drawer-upsell__item';
      li.setAttribute('data-product-id', String(p.id));

      var imgHtml = '';
      var src = p.featured_image;
      if (src && typeof src === 'object') src = src.url || src.src || '';
      if (typeof src === 'string' && src) {
        if (src.indexOf('//') === 0) src = 'https:' + src;
        var sep = src.indexOf('?') >= 0 ? '&' : '?';
        imgHtml =
          '<img class="cart-drawer-upsell__img" src="' +
          src +
          sep +
          'width=120" alt="" width="56" height="56" loading="lazy">';
      } else {
        imgHtml = '<span class="cart-drawer-upsell__img" aria-hidden="true"></span>';
      }

      var price = moneyFromCents(v.price, p.price_currency || undefined);
      li.innerHTML =
        '<a class="cart-drawer-upsell__media" href="' +
        p.url +
        '">' +
        imgHtml +
        '</a>' +
        '<div class="cart-drawer-upsell__info">' +
        '<a class="cart-drawer-upsell__title" href="' +
        p.url +
        '">' +
        (p.title || '') +
        '</a>' +
        '<span class="cart-drawer-upsell__price">' +
        price +
        '</span>' +
        '</div>' +
        '<button type="button" class="cart-drawer-upsell__add" data-variant-id="' +
        v.id +
        '" aria-label="הוספה לסל">הוספה</button>';
      list.appendChild(li);
    }
  }

  function quickAdd(variantId, btn) {
    var cart = document.querySelector('cart-drawer');
    var body = { items: [{ id: Number(variantId), quantity: 1 }] };
    if (cart && typeof cart.getSectionsToRender === 'function') {
      body.sections = cart.getSectionsToRender().map(function (s) {
        return s.id;
      });
      body.sections_url = window.location.pathname;
    }
    if (btn) btn.disabled = true;
    var addUrl = (window.routes && routes.cart_add_url ? routes.cart_add_url : '/cart/add') + '.js';
    return fetch(addUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(body),
    })
      .then(function (r) {
        return r.json().then(function (j) {
          if (!r.ok) throw j;
          return j;
        });
      })
      .then(function (j) {
        if (cart && typeof cart.renderContents === 'function') {
          var it = (j.items && j.items[0]) || {};
          it.sections = j.sections;
          cart.classList.remove('is-empty');
          cart.renderContents(it);
        } else {
          window.location.href = '/cart';
        }
      })
      .catch(function () {
        if (btn) btn.disabled = false;
      });
  }

  function refresh() {
    var root = document.getElementById('CartDrawer-Upsell');
    if (!root) return;
    var productId = root.getAttribute('data-product-id');
    if (!productId) {
      root.hidden = true;
      return;
    }
    var limit = parseInt(root.getAttribute('data-limit') || '3', 10) || 3;
    if (limit < 2) limit = 2;
    if (limit > 3) limit = 3;
    var exclude = cartIdSet(root);
    var key = productId + '|' + root.getAttribute('data-cart-product-ids') + '|' + limit;
    if (root.dataset.loadedKey === key && !root.hidden) return;

    var seq = (pending = {});
    fetchIntent(productId, 'complementary')
      .then(function (data) {
        if (pending !== seq) return null;
        var items = pickProducts(data.products || [], exclude, limit);
        if (items.length) {
          return { items: items, heading: root.getAttribute('data-heading-complementary') || '' };
        }
        return fetchIntent(productId, 'related').then(function (data2) {
          if (pending !== seq) return null;
          return {
            items: pickProducts(data2.products || [], exclude, limit),
            heading: root.getAttribute('data-heading-related') || '',
          };
        });
      })
      .then(function (result) {
        if (!result || pending !== seq) return;
        render(root, result.items, result.heading);
        root.dataset.loadedKey = key;
      })
      .catch(function () {
        if (pending === seq) root.hidden = true;
      });
  }

  function scheduleRefresh() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(refresh, 120);
  }

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest && e.target.closest('.cart-drawer-upsell__add');
    if (!btn) return;
    e.preventDefault();
    var vid = btn.getAttribute('data-variant-id');
    if (vid) quickAdd(vid, btn);
  });

  document.addEventListener('cart-drawer:refreshed', scheduleRefresh);
  document.addEventListener('cart-drawer:opened', scheduleRefresh);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleRefresh);
  } else {
    scheduleRefresh();
  }

  // Qty changes replace .drawer__inner without always firing our events
  var obsTimer = null;
  var obs = new MutationObserver(function () {
    clearTimeout(obsTimer);
    obsTimer = setTimeout(scheduleRefresh, 80);
  });
  function watch() {
    var drawer = document.querySelector('cart-drawer');
    if (drawer) obs.observe(drawer, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch);
  else watch();
})();
